import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useState } from 'react';
import { Bubble, Button } from 'tea-component';

export default function ShowProgress({
  onChange,
  key,
  defaultValue = true,
  defaultParams,
}: any) {
  let { bubbleParams, ...otherParams } = defaultParams;
  const [progressVisible, setProgressVisible] = useState(defaultValue);
  return (
    <Bubble
      dark
      closeOnScroll
      placement="top-end"
      style={{ marginRight: -8 }}
      {...(bubbleParams || {})}
    >
      <Button
        type="icon"
        className="ns-btn--icon dbo-show-progress"
        {...otherParams}
        onClick={() => {
          setProgressVisible(!progressVisible);
          onChange(key, !progressVisible);
        }}
      >
        <SvgIcon type={progressVisible ? 'table-eye' : 'table-noeye'} />
      </Button>
    </Bubble>
  );
}
